import { Entity, Field } from '@adornis/baseql/decorators.js';
import { validate } from '@adornis/validation/decorators.js';
import { minLength } from '@adornis/validation/functions/length.js';
import { Names } from '@ils/static/names.js';
import { CalendarEvent } from './calendarEvent.js';

@Entity()
export class TimeSlot extends CalendarEvent {
  static override _class = Names.TimeSlot._class;

  @validate(minLength(1))
  @Field(type => [String])
  override userIDs!: [string];
}
